<template>
<div class="page-content">
    <div class="product-details-list view-switch">
        <div class="tab-content">

            <div class="tab-pane active" id="school">
                <div class="school-list-container">
                    <div class="school-list-header">
                        <h2>{{level}}概覽 - 搜尋結果<span class="comments">({{total}}間)</span></h2>
                    </div>

                    <div class="school-list-intro">
                        <p>
                            以下列表展示全港所有特殊學校的聯絡資料。你可利用搜尋或篩選功能，迅速找到想查詢的學校。
                        </p>
                    </div>

                    <!-- Search Bar -->
                    <div class="search-bar-wrapper">
                        <div class="search-box">
                            <i class="fas fa-search"></i>
                            <input 
                                v-model="searchKeyword" 
                                @input="doSearch"
                                type="text" 
                                placeholder="搜尋關鍵字...">
                        </div>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-striped table-bordered school-list-table">
                            <colgroup>
                                <col class="col1">
                                <col class="col2">
                                <col class="col3">
                                <col class="col4">
                                <col class="col5">
                                <col class="col6">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th @click="sortBy('中文名稱')" class="sortable">
                                        中文名稱
                                        <span class="sort-indicator">
                                            <span class="sort-arrow up" :class="{ 'active': sortColumn === '中文名稱' && sortDirection === 'asc' }">▲</span>
                                            <span class="sort-arrow down" :class="{ 'active': sortColumn === '中文名稱' && sortDirection === 'desc' }">▼</span>
                                        </span>
                                    </th>
                                    <th @click="sortBy('分區')" class="sortable">
                                        分區
                                        <span class="sort-indicator">
                                            <span class="sort-arrow up" :class="{ 'active': sortColumn === '分區' && sortDirection === 'asc' }">▲</span>
                                            <span class="sort-arrow down" :class="{ 'active': sortColumn === '分區' && sortDirection === 'desc' }">▼</span>
                                        </span>
                                    </th>
                                    <th @click="sortBy('地址')" class="sortable col-sm-show">
                                        地址
                                        <span class="sort-indicator">
                                            <span class="sort-arrow up" :class="{ 'active': sortColumn === '地址' && sortDirection === 'asc' }">▲</span>
                                            <span class="sort-arrow down" :class="{ 'active': sortColumn === '地址' && sortDirection === 'desc' }">▼</span>
                                        </span>
                                    </th>
                                    <th @click="sortBy('電話')" class="sortable col-md-show">
                                        電話
                                        <span class="sort-indicator">
                                            <span class="sort-arrow up" :class="{ 'active': sortColumn === '電話' && sortDirection === 'asc' }">▲</span>
                                            <span class="sort-arrow down" :class="{ 'active': sortColumn === '電話' && sortDirection === 'desc' }">▼</span>
                                        </span>
                                    </th>
                                    <th @click="sortBy('服務類別')" class="sortable col-lg-show">
                                        服務類別
                                        <span class="sort-indicator">
                                            <span class="sort-arrow up" :class="{ 'active': sortColumn === '服務類別' && sortDirection === 'asc' }">▲</span>
                                            <span class="sort-arrow down" :class="{ 'active': sortColumn === '服務類別' && sortDirection === 'desc' }">▼</span>
                                        </span>
                                    </th>
                                    <th @click="sortBy('學生性別')" class="sortable col-xl-show">
                                        性別
                                        <span class="sort-indicator">
                                            <span class="sort-arrow up" :class="{ 'active': sortColumn === '學生性別' && sortDirection === 'asc' }">▲</span>
                                            <span class="sort-arrow down" :class="{ 'active': sortColumn === '學生性別' && sortDirection === 'desc' }">▼</span>
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) of pagedItems" :key="index" :class="{ 'row-even': index % 2 === 0, 'row-odd': index % 2 !== 0 }">
                                    <td>
                                        <a :href="`/sen/${item.中文名稱}`" @click="showDetails()" v-readed-article:SCHOOL-SEN="item">
                                            {{item.中文名稱}}
                                        </a>
                                    </td>
                                    <td>{{item.分區}}</td>
                                    <td class="col-sm-show">{{item.中文地址}}</td>
                                    <td class="col-md-show">{{item.電話}}</td>
                                    <td class="col-lg-show">{{item.服務類別}}</td>
                                    <td class="col-xl-show">{{item.學生性別}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="pagination-wrapper">
                        <nav class="custom-pagination">
                            <ul class="pagination">
                                <li class="page-item" :class="{ 'disabled': currentPage === 1 }">
                                    <a class="page-link" @click="goToPage(1)">«</a>
                                </li>
                                <li class="page-item" :class="{ 'disabled': currentPage === 1 }">
                                    <a class="page-link" @click="goToPage(currentPage - 1)">‹</a>
                                </li>

                                <li class="page-item" v-for="page in visiblePages" :key="page" :class="{ 'active': page === currentPage }">
                                    <a class="page-link" @click="goToPage(page)">{{ page }}</a>
                                </li>

                                <li class="page-item" :class="{ 'disabled': currentPage === totalPages }">
                                    <a class="page-link" @click="goToPage(currentPage + 1)">›</a>
                                </li>
                                <li class="page-item" :class="{ 'disabled': currentPage === totalPages }">
                                    <a class="page-link" @click="goToPage(totalPages)">»</a>
                                </li>
                            </ul>
                        </nav>
                        <div class="pagination-info" v-if="total > 0">
                            顯示第 {{ (currentPage - 1) * perPage + 1 }} 至 {{ Math.min(currentPage * perPage, total) }} 條記錄，共 {{ total }} 條
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</div>
</template>

<script>
import * as mixin from './SenSchoolListViewMixin.vue';
let listView = Vue.extend({
    mixins: [mixin],
    props: {
        currentPage: {
            type: Number,
            default: 1
        },
        perPage: {
            type: Number,
            default: 20
        },
        pagedItems: {
            type: Array,
            default: () => []
        },
        total: {
            type: Number,
            default: 0
        },
        level: {
            type: String,
            default: '特殊學校'
        },
        loading: {
            type: Boolean,
            default: false
        },
        model: {
            type: Object,
            default: () => ({
                keyword: '',
                districts: {},
                religious: {},
                financeTypes: {},
                genders: {}
            })
        }
    },
    data() {
        return {
            sortColumn: '',
            sortDirection: 'asc',
            searchKeyword: ''
        };
    },
    watch: {
        model: {
            handler(newVal) {
                if (newVal && newVal.keyword) {
                    this.searchKeyword = newVal.keyword;
                }
            },
            immediate: true
        }
    },
    computed: {
        totalPages() {
            return Math.ceil(this.total / this.perPage);
        },
        visiblePages() {
            const pages = [];
            const maxVisible = 5;
            let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
            let end = Math.min(this.totalPages, start + maxVisible - 1);

            if (end - start + 1 < maxVisible) {
                start = Math.max(1, end - maxVisible + 1);
            }

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }
            return pages;
        }
    },
    methods: {
        sortBy(column) {
            if (this.sortColumn === column) {
                this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortColumn = column;
                this.sortDirection = 'asc';
            }
            this.$emit('sortFromView', column, this.sortDirection);
        },
        goToPage(page) {
            if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
                this.$emit('pageChange', page);
            }
        },
        doSearch() {
            if (this.model) {
                this.model.keyword = this.searchKeyword;
                this.$emit('filterOnChange', this.model);
            }
        },
        showDetails() {
            this.$emit('showDetails', true);
        }
    }
});
export default listView;
</script>

<style scoped>
.page-content {
    padding: 20px;
    min-height: 100vh;
}

.school-list-container {
    max-width: 1680px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.school-list-header {
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 2px solid #f0f0f0;
}

.school-list-header h2 {
    font-size: 24px;
    font-weight: 600;
    color: #333;
    margin: 0;
}

.school-list-header h2 .comments {
    color: #666;
    font-weight: 400;
    margin-left: 10px;
}

.school-list-intro {
    background-color: #f8f9fa;
    border-left: 4px solid #337ab7;
    padding: 15px 20px;
    margin-bottom: 25px;
    border-radius: 0 8px 8px 0;
}

.school-list-intro p {
    margin: 0;
    color: #555;
    line-height: 1.7;
    font-size: 14px;
}

.school-list-table {
    margin-bottom: 0;
    width: 100%;
    table-layout: fixed;
    border-collapse: separate;
    border-spacing: 0;
}

/* Responsive col widths - 6 columns: 中文名稱, 分區, 地址, 電話, 服務類別, 性別 */
/* Default (6 cols): 30%, 10%, 25%, 15%, 10%, 10% = 100% */
.school-list-table .col1 { width: 25%; }
.school-list-table .col2 { width: 10%; }
.school-list-table .col3 { width: 25%; }
.school-list-table .col4 { width: 15%; }
.school-list-table .col5 { width: 15%; }
.school-list-table .col6 { width: 10%; }

/* 5 cols (xl hidden): 33%, 11%, 28%, 17%, 11% */
@media (max-width: 1199px) {
    .school-list-table .col1 { width: 29%; }
    .school-list-table .col2 { width: 11%; }
    .school-list-table .col3 { width: 25%; }
    .school-list-table .col4 { width: 17%; }
    .school-list-table .col5 { width: 18%; }
    .school-list-table .col6,
    .school-list-table th.col-xl-show,
    .school-list-table td.col-xl-show { width: 0; display: none; }
}

/* 4 cols (lg hidden): 35%, 15%, 30%, 20% */
@media (max-width: 991px) {
    .school-list-table .col1 { width: 35%; }
    .school-list-table .col2 { width: 15%; }
    .school-list-table .col3 { width: 30%; }
    .school-list-table .col4 { width: 20%; }
    .school-list-table .col5,
    .school-list-table .col6,
    .school-list-table th.col-lg-show, .school-list-table td.col-lg-show,
    .school-list-table th.col-xl-show, .school-list-table td.col-xl-show { width: 0; display: none; }
}

/* 3 cols (md hidden): 40%, 20%, 40% */
@media (max-width: 767px) {
    .school-list-table .col1 { width: 40%; }
    .school-list-table .col2 { width: 20%; }
    .school-list-table .col3 { width: 40%; }
    .school-list-table .col4,
    .school-list-table .col5,
    .school-list-table .col6,
    .school-list-table th.col-md-show, .school-list-table td.col-md-show,
    .school-list-table th.col-lg-show, .school-list-table td.col-lg-show,
    .school-list-table th.col-xl-show, .school-list-table td.col-xl-show { width: 0; display: none; }
}

/* 2 cols (sm hidden): 70%, 30% */
@media (max-width: 575px) {
    .school-list-table .col1 { width: 70%; }
    .school-list-table .col2 { width: 30%; }
    .school-list-table .col3,
    .school-list-table .col4,
    .school-list-table .col5,
    .school-list-table .col6,
    .school-list-table th.col-sm-show, .school-list-table td.col-sm-show,
    .school-list-table th.col-md-show, .school-list-table td.col-md-show,
    .school-list-table th.col-lg-show, .school-list-table td.col-lg-show,
    .school-list-table th.col-xl-show, .school-list-table td.col-xl-show { width: 0; display: none; }
}

.school-list-table thead tr {
    background-color: #f8f9fa;
}

.school-list-table th {
    background-color: #e9ecef;
    font-weight: 600;
    white-space: nowrap;
    text-align: center;
    padding: 14px 10px;
    border-bottom: 2px solid #dee2e6;
    color: #495057;
}

.school-list-table th:first-child {
    text-align: left;
    border-radius: 8px 0 0 0;
}

.school-list-table th:last-child {
    border-radius: 0 8px 0 0;
}

.school-list-table th:nth-child(3) {
    text-align: left;
}

.school-list-table td {
    text-align: center;
    padding: 12px 10px;
    vertical-align: middle;
    border-bottom: 1px solid #eee;
    overflow: hidden;
    text-overflow: ellipsis;
}

.school-list-table td:first-child {
    text-align: left;
}

.school-list-table td:nth-child(3) {
    text-align: left;
}

.school-list-table tbody tr {
    transition: background-color 0.2s ease;
}

.school-list-table tbody tr.row-even {
    background-color: #ffffff;
}

.school-list-table tbody tr.row-odd {
    background-color: #fafbfc;
}

.school-list-table tbody tr:hover {
    background-color: #e8f4fc !important;
}

.school-list-table th.sortable {
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s;
}

.school-list-table th.sortable:hover {
    background-color: #dde2e8;
}

.sort-indicator {
    display: inline-flex;
    flex-direction: column;
    margin-left: 5px;
    font-size: 8px;
    vertical-align: middle;
}

.sort-indicator .sort-arrow {
    line-height: 1;
    color: #999;
    transition: color 0.2s;
}

.sort-indicator .sort-arrow.active {
    color: #337ab7;
}

.school-list-table td a {
    color: #337ab7;
    text-decoration: none;
    transition: color 0.2s;
}

.school-list-table td a:hover {
    color: #23527c;
    text-decoration: underline;
}

.pagination-wrapper {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
}

.custom-pagination {
    display: flex;
    justify-content: center;
}

.custom-pagination .pagination {
    margin: 0;
    display: flex;
    gap: 5px;
    list-style: none;
    padding: 0;
}

.custom-pagination .page-item {
    margin: 0;
}

.custom-pagination .page-link {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 36px;
    height: 36px;
    padding: 0 10px;
    border: 1px solid #ddd;
    border-radius: 6px;
    color: #333;
    text-decoration: none;
    font-size: 14px;
    background-color: #fff;
    transition: all 0.2s ease;
    cursor: pointer;
}

.custom-pagination .page-link:hover {
    background-color: #f0f0f0;
    border-color: #ccc;
}

.custom-pagination .page-item.active .page-link {
    background-color: #337ab7;
    border-color: #337ab7;
    color: #fff !important;
}

.custom-pagination .page-item.disabled .page-link {
    color: #ccc;
    cursor: not-allowed;
    background-color: #f9f9f9;
}

.pagination-info {
    color: #666;
    font-size: 13px;
}

.col-xl-show,
.col-lg-show,
.col-md-show,
.col-sm-show {
    display: table-cell;
}

@media (max-width: 575px) {
    .school-list-container {
        padding: 15px;
        border-radius: 8px;
    }

    .school-list-header h2 {
        font-size: 18px;
    }

    .school-list-intro {
        padding: 12px 15px;
    }

    .school-list-intro p {
        font-size: 13px;
    }

    .school-list-table th,
    .school-list-table td {
        padding: 10px 6px;
        font-size: 13px;
    }

    .pagination-info {
        font-size: 12px;
        text-align: center;
    }
}

/* Search Bar Styles */
.search-bar-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 8px;
}

.search-box {
    position: relative;
    flex: 1;
    max-width: 400px;
}

.search-box i {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #999;
}

.search-box input {
    width: 100%;
    padding: 10px 12px 10px 35px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 14px;
    transition: border-color 0.2s;
}

.search-box input:focus {
    outline: none;
    border-color: #337ab7;
}

@media (max-width: 767px) {
    .search-bar-wrapper {
        flex-direction: column;
        align-items: stretch;
    }

    .search-box {
        max-width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/sen-school/SenSchoolListView.vue